import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { GlobalConfig } from '../app/app.config';
@Pipe({
  name: 'groupBy',
  pure: true
})
@Injectable()
export class GroupByPipe implements PipeTransform {

  transform(value: Array<any>, field: string, order: boolean = false, orderInvert: boolean = false): Array<any> {
    let newData;

    if (value) {
      const groupedObj = value.reduce((prev, cur)=> {
        if(!prev[cur[field]]) {
          prev[cur[field]] = [cur];
        } else {
          prev[cur[field]].push(cur);
        }
        return prev;
      }, {});

      newData = Object.keys(groupedObj).map(key => ({ key, value: groupedObj[key] }));

      newData.forEach(element => {
        let newValue = element.value.sort((a, b) => {
          let newA = new Date(element.key + 'T' + a.start + '' + GlobalConfig._timezoneHour);
          let newB = new Date(element.key + 'T' + b.start + '' + GlobalConfig._timezoneHour);

          return newA > newB ? 1 : -1;
        });

        element.value = newValue;
      });

      if (order) {
        // Ordering by key
        newData = newData.sort((a, b) => {
          if (orderInvert) {
            return a.key < b.key;
          } else {
            return a.key > b.key;
          }
        });
      }

      return newData;
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/group-by.ts